import React from 'react';
import {Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from 'recharts';

interface CatchOverview {
  totalCatches: number;
  totalTaken: number;
  totalReleased: number;
  totalUnknown: number;
  totalMembers: number;
  activeFishermen: number;
}

export const CatchOverviewDonut = ({data}: { data: CatchOverview | null }) => {
  if (!data) {
    return (
      <div className="card h-100">
        <div className="card-header">
          <h3 className="card-title">Entnahme vs. Zurückgesetzt</h3>
        </div>
        <div className="card-body">
          <div className="text-muted">Keine Daten verfügbar</div>
        </div>
      </div>
    );
  }

  const chartData = [
    {name: 'Entnommen', value: data.totalTaken},
    {name: 'Zurückgesetzt', value: data.totalReleased},
    {name: 'Unbekannt', value: data.totalUnknown}
  ];

  const COLORS = ['#ef4444', '#10b981', '#6b7280'];

  return (
    <div className="card h-100">
      <div className="card-header">
        <h3 className="card-title">Entnahme vs. Zurückgesetzt</h3>
      </div>
      <div className="card-body">
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              paddingAngle={2}
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
        <div className="mt-3 text-center">
          <div className="text-muted">
            Entnahmequote: <strong>{((data.totalTaken / data.totalCatches) * 100).toFixed(1)}%</strong>
          </div>
        </div>
      </div>
    </div>
  );
};
